import React from 'react';
import {CircularProgress} from "@/component/view/CircularProgress";

export function LoadingSpinner() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
      <CircularProgress size={50}/>
    </div>
  );
} 